import React, {useState} from 'react';
import { useStaticQuery, graphql } from "gatsby";
import EcoAllianceBenefits from '../EcoAllianceBenefits/EcoAllianceBenefits';
import EcoAllianceHeader from '../EcoAllianceHeader/EcoAllianceHeader';
import EcoAllianceJoin from '../EcoAllianceJoin/EcoAllianceJoin';
import EcoAllianceReel from '../EcoAllianceReel/EcoAllianceReel';
import EcoAllianceSupport from '../EcoAllianceSupport/EcoAllianceSupport';
import EcoAllianceSustainability from '../EcoAllianceSustainability/EcoAllianceSustainability';
import EcoAllianceSlidePanel from '../EcoAllianceSlidePanel/EcoAllianceSlidePanel';

const EcoAlliance = () => {

  const [isOpen, setIsOpen] = useState(false);
  const [location, setLocation] = useState({});

  const query = useStaticQuery(graphql`
    query bizAdvice2 {
      posts: allGhostPost(
          filter: { tags: { elemMatch: { slug: {eq: "eco-alliance"} } } }
          sort: { order: DESC, fields: [published_at] }
          limit: 2000
      ) {
          edges {
              node {
                  id
                  title
                  slug
                  feature_image
                  excerpt
                  published_at(formatString: "DD MMMM YYYY")
                  primary_author {
                      name
                      slug
                      profile_image
                  }
                  tags {
                      name
                      slug
                  }
                  url
              }
          }
      }
    }
  `);

  const { posts : { edges : blogsLIst}} = query;
  
  const onMarkerSelected = marker => {
    setLocation(marker);
    setIsOpen(true);
  }

  return (
    <>
      <EcoAllianceHeader onClicked={(marker)=>onMarkerSelected(marker)} />
      <EcoAllianceReel />
      <EcoAllianceSustainability />
      <EcoAllianceSupport />
      <EcoAllianceJoin />
      <EcoAllianceBenefits />
      <EcoAllianceSlidePanel blogsList={blogsLIst} location={location} isOpen={isOpen} onClose={()=>setIsOpen(false)} />
    </>
  )
}

export default EcoAlliance;